import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import no from './locales/no.json';

// Get saved language from localStorage or use default
const getSavedLanguage = (): string => {
  const saved = localStorage.getItem('i18nextLng');
  const supportedLanguages = ['no', 'en'];
  
  if (saved && supportedLanguages.includes(saved)) {
    return saved;
  }
  
  // Try to detect browser language
  const browserLang = navigator.language.split('-')[0];
  if (supportedLanguages.includes(browserLang)) {
    return browserLang;
  }
  
  // Default to Norwegian
  return 'no';
};

const initialLanguage = getSavedLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'no', // Norwegian as default
    lng: initialLanguage, // Start with saved or detected language
    debug: process.env.NODE_ENV === 'development',
    returnObjects: true, // Allow returning arrays and objects from translations

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    resources: {
      no: {
        translation: no,
      },
      en: {
        translation: en,
      },
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'], // Don't cache during development
      convertDetectedLanguage: (lng: string) => {
        // Only allow supported languages
        const supportedLanguages = ['no', 'en'];
        const detected = lng.split('-')[0];
        return supportedLanguages.includes(detected) ? detected : 'no';
      },
    },
  });

export default i18n;
